/**
 * Staging Environment Configuration
 * Used for provisioning-admin-stag.anepanywhere.com
 */

export const stagingConfig = {
  environment: 'staging',
  hostname: 'provisioning-admin-stag.anepanywhere.com',

  api: {
    baseUrl: '/api',
    firmwareBaseUrl: 'https://provisioning-stag.anepanywhere.com',
  },

  oauth: {
    clientId: 'provisioning-staging',
    redirectUri: 'https://provisioning-admin-stag.anepanywhere.com/auth/callback',
    authUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/auth',
    tokenUrl: 'https://keycloak.anepanywhere.com/realms/provisioning-anep/protocol/openid-connect/token',
  },

  ui: {
    title: 'ANEP Device Provisioning [STAGING]',
    logoUrl: '/logo.png',
    companyName: 'ANEP',
    primaryColor: '#215EA1',
  },

  dev: {
    debug: false,
  },
} as const;

export default stagingConfig;
